import { FetchOptions } from "../interfaces/fetchOptions.interface";
import { getApiUrl } from "./getApiUrl.helper";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type QueryObject = Record<string, any>;

export const fetchHandler = (
    fetchWithAuth: (url: RequestInfo, options?: RequestInit) => Promise<Response>,
    rootUrl: string,
    method: "POST" | "PUT" | "PATCH" | "DELETE",
    path: string,
    parameters: QueryObject | string | number | boolean | FormData,
    options?: FetchOptions
) => {
    const isFormData = parameters instanceof FormData;

    const fetchOptions: RequestInit = {
        ...options,
        method,
        credentials: method === "PATCH" || method === "DELETE" ? "include" : undefined,
        body:
            typeof parameters === "undefined"
                ? undefined
                : isFormData
                ? (parameters as FormData)
                : typeof parameters === "object"
                ? JSON.stringify(parameters)
                : parameters.toString(),
    };

    if (!isFormData) {
        fetchOptions.headers = {
            "Content-Type": "application/json",
            ...(options?.headers || {}),
        };
    } // For FormData, let the browser set the headers automatically

    return fetchWithAuth(getApiUrl(rootUrl, path), fetchOptions);
};
